(function () {
  'use strict';

  function init(config) {
    if (config.dataset.eveCtaBound) return;
    var data;
    try { data = JSON.parse(config.textContent); } catch (error) { return; }
    var form = document.getElementById(data.formId);
    var section = form && form.closest('.shopify-section');
    var button = form && form.querySelector('button[name="add"]');
    var amount = button && button.querySelector('[data-eve-product-amount]');
    if (!section || !button || !amount) return;
    config.dataset.eveCtaBound = 'true';

    var formatter;
    try {
      formatter = new Intl.NumberFormat(data.locale, { style: 'currency', currency: data.currency });
    } catch (error) { /* Unit quantities keep the server-rendered money format. */ }

    function selectedVariant() {
      var pack = section.querySelector('input[name="Pack"]:checked');
      var size = section.querySelector('input[name="Taille"]:checked');
      if (pack && size && data.variants[0].options.length === 2) {
        return data.variants.find(function (variant) {
          return variant.options[0] === pack.value && variant.options[1] === size.value;
        });
      }
      var picker = section.querySelector('variant-radios, variant-selects');
      if (picker && data.variants[0].options.length === 1) {
        var choice = picker.querySelector('input[type="radio"]:checked, select');
        if (choice) {
          return data.variants.find(function (variant) { return variant.options[0] === choice.value; });
        }
      }
      var input = form.elements.namedItem('id');
      return input && data.variants.find(function (variant) { return String(variant.id) === input.value; });
    }

    function promoMinorUnits(text) {
      var numeric = text.replace(/[^0-9.,]/g, '');
      if (!numeric) return NaN;
      // Theme promotion text uses a currency amount, with an optional 1–2 digit decimal part.
      var decimal = numeric.match(/[.,](\d{1,2})$/);
      if (decimal) {
        return Number(numeric.slice(0, decimal.index).replace(/[.,]/g, '')) * 100 +
          Number((decimal[1] + '0').slice(0, 2));
      }
      return Number(numeric.replace(/[.,]/g, '')) * 100;
    }

    function update() {
      if (!form.isConnected) return;
      var variant = selectedVariant();
      var quantityInput = form.elements.namedItem('quantity');
      var quantity = quantityInput ? Number(quantityInput.value) : 1;
      var valid = variant && variant.available && Number.isInteger(quantity) && quantity > 0;
      amount.hidden = !valid;
      if (!valid) return;

      var unitPrice = variant.price;
      var unitMoney = variant.money;
      // Keep URL promotion amounts consistent with the active pack's visible price.
      var promo = section.querySelector('.bundle.active .pricebundle-promo');
      if (promo && promo.style.display !== 'none' && promo.textContent.trim()) {
        var promoMoney = promo.textContent.trim();
        var promoPrice = promoMinorUnits(promoMoney);
        if (Number.isFinite(promoPrice)) {
          unitPrice = promoPrice;
          unitMoney = promoMoney;
        }
      }
      var money = quantity === 1 ? unitMoney : formatter && formatter.format(unitPrice * quantity / 100);
      if (!money) { amount.hidden = true; return; }
      var text = ' · ' + money;
      if (amount.textContent !== text) amount.textContent = text;
    }

    // Variant scripts dispatch a change on the hidden id; quantity inputs share its form.
    section.addEventListener('change', update);
    section.addEventListener('input', function (event) {
      if (event.target.name === 'quantity') update();
    });
    // jQuery pack/size handlers finish before the native click bubbles to the section.
    section.addEventListener('click', function (event) {
      if (event.target.closest('.bundle, .modeunit, .modepack, .product-form__input label')) update();
    });
    update();
  }

  function initAll(root) {
    root.querySelectorAll('[data-eve-product-cta-config]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
